export default __webpack_public_path__ + "b42847e14af16e5387035e7df6f533f2.svg";